export default __webpack_public_path__ + "static/media/Care12.89f80e0f.png";